import { memo, useMemo } from "react";
import { ReactComponent as OrigMinerView } from "@assets/redesign/icons/minerScheme.svg";
import { ReactComponent as WlpMinerView } from "@components/WLP202603/assets/redesign/icons/minerScheme.svg";
import cn from "classnames";
import { IMinerViewBlockProps } from "./MinerViewBlock.props";
import { useMinerViewBlockControl } from "./useMinerViewBlockControl";
import { useIntl } from "react-intl";
import styles from "./MinerViewBlock.module.scss";
import { Input } from "@components/global/new/Input/Input";
import { WLP202603 } from "../../../../../config";

const MinerView = WLP202603 ? WlpMinerView : OrigMinerView;

function MinerViewBlock(props: IMinerViewBlockProps) {
  const { formatMessage } = useIntl();

  const control = useMinerViewBlockControl(props);

  const makeUnit = (param?: number) => {
    if (!param) return;
    // const { value, unit } = control.lengthConverter(param);
    return `${formatMessage(
      { id: "manage.profile.params.unit" },
      { value: param, unit: "мм" }
    )}`;
  };

  const hPlaceHolder = `${formatMessage({
    id: "manage.profile.height",
  })}, ${formatMessage(
    { id: "manage.profile.params.unit" },
    { value: "", unit: "мм" }
  )}`;

  const wPlaceHolder = `${formatMessage({
    id: "manage.profile.width",
  })}, ${formatMessage(
    { id: "manage.profile.params.unit" },
    { value: "", unit: "мм" }
  )}`;

  const dPlaceHolder = `${formatMessage({
    id: "manage.profile.depth",
  })}, ${formatMessage(
    { id: "manage.profile.params.unit" },
    { value: "", unit: "мм" }
  )}`;

  const volume = useMemo(() => {
    if (control.depth && control.height && control.width) {
      return control.depth * control.height * control.width;
    }
  }, [control.depth, control.height, control.width, props.meta]);

  const { value, unit } = useMemo(() => {
    if (!volume)
      return {
        value: 0,
        unit: "",
      };
    return control.lengthConverter(volume);
  }, [volume]);

  //console.log(props.meta);

  return (
    <div className={cn(styles.miner_view)}>
      <MinerView />
      <div className={styles.params}>
        <span className={styles.volume}>
          {formatMessage({ id: "manage.profile.volume" })}:{" "}
          {formatMessage({ id: "manage.profile.params.unit" }, { value, unit })}
          <sup>3</sup>
        </span>
        <Input
          type='number'
          size="small"
          label={hPlaceHolder}
          placeholder={hPlaceHolder}
          outlined={!props.disabled && !props.checkErrors?.("height")}
          readOnly={props.disabled}
          defaultValue={`${props.meta?.height || ""}`.trim() || "0"}
          onChange={(e) => control.setMinerParam(+e.currentTarget.value, "h")}
          status={props.checkErrors?.("height") && "error" || ""}
          id='height'
        />
        <Input
          type='number'
          size="small"
          label={wPlaceHolder}
          placeholder={wPlaceHolder}
          outlined={!props.disabled && !props.checkErrors?.("width")}
          readOnly={props.disabled}
          defaultValue={`${props.meta?.width || ""}`.trim() || "0"}
          status={props.checkErrors?.("width") && "error" || ""}
          onChange={(e) => control.setMinerParam(+e.currentTarget.value, "w")}
          id='width'
        />
        <Input
          type='number'
          size="small"
          label={dPlaceHolder}
          placeholder={dPlaceHolder}
          outlined={!props.disabled && !props.checkErrors?.("depth")}
          readOnly={props.disabled}
          defaultValue={`${props.meta?.depth || ""}`.trim() || "0"}
          status={props.checkErrors?.("depth") && "error" || ""}
          onChange={(e) => control.setMinerParam(+e.currentTarget.value, "d")}
          id='depth'
        />
      </div>
    </div>
  );
}
export default memo(MinerViewBlock);
